export const AddressForm = [
  {
    text: 'Name*',
    id: 'name',
    type: '1',
    value: '',
    placeHolder: 'Name*',
    required: true,
    validation: true,
    focus: false,
    errorText: 'Full Name',
  },
  {
    text: 'Mobile No.*',
    id: 'mobile',
    type: '1',
    value: '',
    placeHolder: 'Mobile No.*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Pincode* 6 digits [ 0-9 ]',
    id: 'zipcode',
    type: '1',
    value: '',
    placeHolder: 'Pincode* 6 digits',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Address Line 1*',
    id: 'address_line_1',
    type: '1',
    value: '',
    placeHolder: 'House / Flat No. / Floor*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Address Line 2',
    id: 'address_line_2',
    type: '1',
    value: '',
    placeHolder: 'Colony / Street / Locality',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'City*',
    id: 'city',
    type: '1',
    value: '',
    placeHolder: 'City*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'State*',
    id: 'state',
    type: '1',
    value: '',
    placeHolder: 'State*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Type of Address',
    id: 'address_type',
    type: '1',
    value: 'Home',
    options: [{ value: 'Home' }, { value: 'Office' }],
    placeHolder: '',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'is_default',
    id: 'is_default',
    type: '1',
    value: true,
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'country',
    id: 'country',
    type: '1',
    value: 'India',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'Email',
    id: 'email',
    type: '2',
    value: '',
    placeHolder: 'Email',
    required: true,
    validation: true,
    focus: true,
    errorText: 'Email ID',
  },
];
export const AddressFormExperiment = [
  {
    text: 'Name*',
    id: 'name',
    type: '1',
    value: '',
    placeHolder: 'Name*',
    required: true,
    validation: true,
    focus: false,
    errorText: 'Full Name',
  },
  {
    text: 'Mobile No.*',
    id: 'mobile',
    type: '1',
    value: '',
    placeHolder: 'Mobile No.*',
    required: true,
    validation: true,
    focus: false,
    otpFieldData: {
      text: 'Enter OTP',
      id: 'otp_mobile',
      type: '1',
      value: '',
      placeHolder: 'Enter OTP',
      required: true,
      validation: true,
      focus: false,
    },
  },
  {
    text: 'Pincode* 6 digits [ 0-9 ]',
    id: 'zipcode',
    type: '1',
    value: '',
    placeHolder: 'Pincode* 6 digits',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Address Line 1*',
    id: 'address_line_1',
    type: '1',
    value: '',
    placeHolder: 'House / Flat No. / Floor*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Address Line 2',
    id: 'address_line_2',
    type: '1',
    value: '',
    placeHolder: 'Colony / Street / Locality',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'City*',
    id: 'city',
    type: '1',
    value: '',
    placeHolder: 'City*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'State*',
    id: 'state',
    type: '1',
    value: '',
    placeHolder: 'State*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Type of Address',
    id: 'address_type',
    type: '1',
    value: 'Home',
    options: [{ value: 'Home' }, { value: 'Office' }],
    placeHolder: '',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'is_default',
    id: 'is_default',
    type: '1',
    value: true,
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'country',
    id: 'country',
    type: '1',
    value: 'India',
    required: false,
    validation: true,
    focus: false,
  },
  // {
  //     text: "Email",
  //     id: "email",
  //     type: "2",
  //     value: "",
  //     placeHolder: "Email",
  //     required: true,
  //     validation: true,
  //     focus: true,
  //     errorText: "Email ID",
  // },
];
export const states = [
  {
    key: 'AN',
    name: 'Andaman and Nicobar Islands',
  },
  {
    key: 'AP',
    name: 'Andhra Pradesh',
  },
  {
    key: 'AR',
    name: 'Arunachal Pradesh',
  },
  {
    key: 'AS',
    name: 'Assam',
  },
  {
    key: 'BR',
    name: 'Bihar',
  },
  {
    key: 'CG',
    name: 'Chandigarh',
  },
  {
    key: 'CH',
    name: 'Chhattisgarh',
  },
  {
    key: 'DH',
    name: 'Dadra and Nagar Haveli',
  },
  {
    key: 'DD',
    name: 'Daman and Diu',
  },
  {
    key: 'DL',
    name: 'Delhi',
  },
  {
    key: 'GA',
    name: 'Goa',
  },
  {
    key: 'GJ',
    name: 'Gujarat',
  },
  {
    key: 'HR',
    name: 'Haryana',
  },
  {
    key: 'HP',
    name: 'Himachal Pradesh',
  },
  {
    key: 'Ja',
    name: 'Jammu',
  },
  {
    key: 'JH',
    name: 'Jharkhand',
  },
  {
    key: 'KA',
    name: 'Karnataka',
  },
  {
    key: 'Kr',
    name: 'Kashmir',
  },
  {
    key: 'KL',
    name: 'Kerala',
  },
  {
    key: 'LD',
    name: 'Lakshadweep',
  },
  {
    key: 'MP',
    name: 'Madhya Pradesh',
  },
  {
    key: 'MH',
    name: 'Maharashtra',
  },
  {
    key: 'MN',
    name: 'Manipur',
  },
  {
    key: 'ML',
    name: 'Meghalaya',
  },
  {
    key: 'MZ',
    name: 'Mizoram',
  },
  {
    key: 'NL',
    name: 'Nagaland',
  },
  {
    key: 'OR',
    name: 'Odisha',
  },
  {
    key: 'PY',
    name: 'Puducherry',
  },
  {
    key: 'PB',
    name: 'Punjab',
  },
  {
    key: 'RJ',
    name: 'Rajasthan',
  },
  {
    key: 'SK',
    name: 'Sikkim',
  },
  {
    key: 'TN',
    name: 'Tamil Nadu',
  },
  {
    key: 'TS',
    name: 'Telangana',
  },
  {
    key: 'TR',
    name: 'Tripura',
  },
  {
    key: 'UK',
    name: 'Uttar Pradesh',
  },
  {
    key: 'UP',
    name: 'Uttarakhand',
  },
  {
    key: 'WB',
    name: 'West Bengal',
  },
];
export const enteredNameCategory = 'entered_name_addr_pg';
export const enteredPhoneCategory = 'entered_phone_addr_pg';
export const enteredPinCategory = 'entered_pincode_addr_pg';
export const enteredStateCategory = 'entered_state_addr_pg';
export const enteredCityCategory = 'entered_city_addr_pg';
export const enteredAddress1Category = 'entered_address_line_1_addr_pg';
export const enteredAddress2Category = 'entered_address_line_2_addr_pg';
export const enteredEmailCategory = 'entered_email_addr_pg';
export const selectAddressType = 'selected_address_type_addr_pg';
export const servedStrip = 'served_strip';

export const AddressFormUAE = [
  {
    text: 'Emirate*',
    id: 'state',
    type: '1',
    value: 'Dubai',
    placeHolder: 'Emirate*',
    required: true,
    validation: true,
    focus: false,
  },

  {
    text: 'Area*',
    id: 'city',
    type: '1',
    value: '',
    placeHolder: 'Area*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Delivery Address*',
    id: 'address_line_1',
    type: '1',
    value: '',
    placeHolder: 'Delivery Address*',
    required: true,
    validation: true,
    focus: false,
  },
  {
    text: 'Apartment / Hotel Room / Villa*',
    id: 'address_line_2',
    type: '1',
    value: '',
    placeHolder: 'Apartment / Hotel Room / Villa*',
    required: true,
    validation: true,
    focus: false,
  },

  {
    text: 'First Name*',
    id: 'firstname',
    type: '1',
    value: '',
    placeHolder: 'First Name*',
    required: true,
    validation: true,
    focus: false,
    errorText: 'First Name',
  },
  {
    text: 'Last Name',
    id: 'lastname',
    type: '1',
    value: '',
    placeHolder: 'Last Name',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'Email',
    id: 'email',
    type: '2',
    value: '',
    placeHolder: 'Email',
    required: false,
    validation: true,
    focus: false,
  },
  {
    text: 'Mobile No.*',
    id: 'mobile',
    type: '3',
    value: '',
    placeHolder: 'Mobile No.*',
    required: true,
    validation: true,
    focus: false,
  },
];
export const statesUAE = [
  {
    key: 'DU',
    name: 'Dubai',
  },
  {
    key: 'AD',
    name: 'Abu Dhabi',
  },
  {
    key: 'SH',
    name: 'Sharjah',
  },
  {
    key: 'AJ',
    name: 'Ajman',
  },
  {
    key: 'RK',
    name: 'Ras Al Khaimah',
  },
  {
    key: 'FU',
    name: 'Fujairah',
  },
  {
    key: 'UQ',
    name: 'Umm al-Quwain',
  },
  {
    key: 'AA',
    name: 'Al AIN',
  },
];

export const mobileRegexIndia = /[6-9]{1}[0-9]{9}/;
export const mobileRegexUAE =
  /^(?:00971|\+971|0)?(?:50|51|52|55|56|58|2|3|4|6|7|9)\d{7}$/;
// /^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
// /^(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;

export const UAECountryCode = '+971';
export const showStrip = () => {
  return true;
};

export const showBackPressPopup = () => {
  return true;
};
